import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from '../alert';
import { StorageService } from 'app/services/storage.service';
import { PrintService } from 'app/services/print.service';

@Component({
  selector: 'app-storage-place',
  providers: [StorageService, PrintService],
  templateUrl: './storage-place.component.html',
  styleUrls: ['./storage-place.component.css']
})
export class StoragePlaceComponent implements OnInit {

  loading = false;
  containers: any[] = [];
  container: any = null;
  containersFiltered: any[] = [];

  constructor(
    private router: Router,
    private storageService: StorageService,
    private printService: PrintService) { }

  ngOnInit() {
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    await this.getContainers();
    this.loading = false;
  }

  doesMatch(element: any, filter) {
    return ((element != null && element.toLowerCase().indexOf(filter.toLowerCase())) >= 0);
  }

  doFilter(filterValue) {
    this.containersFiltered = [];
    this.containers.forEach(container => {
      if (this.doesMatch(container.name, filterValue)) {
        this.containersFiltered.push(container);
      }
    });
  }

  async getContainers(): Promise<void> {
    this.loading = true;
    try {
    // here all container for that warehouse should be shown
    this.containers = await this.storageService.getContainers('FUL_CONTAINER').toPromise();
    let shelves = await this.storageService.getContainers('FUL_SHELF').toPromise();
    for (let shelf of shelves) {
      this.containers.push(shelf);
    }
  } catch (error) {
    // no containers found
  } finally {
    this.doFilter('');
    this.loading = false;
  }
    
  }

  addContainer() {
      this.router.navigate(['/container', 'new']);
  }

  printLabel(container: any) {
    this._printLabel(container.name);

  }


private async _printLabel(containerName: string): Promise<void> {
  // first download
    await this.storageService.getContainerLabel(containerName).toPromise();
    await this.sleep(1000);
    // then print
    await this.printService.print('labelPrinter', containerName).toPromise();
}

sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/storage-place/storage-place.component.ts